import {
  MANUALLY_PASS_MEMBER_FAIL,
  MANUALLY_PASS_MEMBER_MESSAGE,
  MANUALLY_PASS_MEMBER_SUBMESSAGE,
  MANUALLY_PASS_MEMBER_SUCCESS,
  MANUALLY_PASS_MEMBER_TITLE
} from '@bo-constants/member/memberCopy';
import { useCallback, useMemo } from 'react';
import { MemberConfirmationModal } from '@bo-components/members/modal';
import { cn } from '@library/component-utils/cn';
import { useMemberHeaderKebabActions } from '@bo-hooks/members';

export interface ManuallyPassMemberModalProps {
  memberId: string;
  onClose: () => void;
}

export const ManuallyPassMemberModal = ({
  memberId,
  onClose
}: ManuallyPassMemberModalProps) => {
  const {
    isActionError,
    isActionSuccess,
    isButtonDisabled,
    onSubmitManuallyPassMember
  } = useMemberHeaderKebabActions();

  const showConfirmationMessage = isActionError || isActionSuccess;

  const handleSubmit = useCallback(async () => {
    await onSubmitManuallyPassMember?.(memberId);
  }, [memberId, onSubmitManuallyPassMember]);

  const ManuallyPassMessage = useMemo(() => {
    return (
      <div className="text-soClean-180 flex flex-col gap-4 text-sm">
        <p>{MANUALLY_PASS_MEMBER_MESSAGE}</p>
        <p>{MANUALLY_PASS_MEMBER_SUBMESSAGE}</p>
      </div>
    );
  }, []);

  const ConfirmationMessage = useMemo(() => {
    const confirmationMessage = isActionSuccess
      ? MANUALLY_PASS_MEMBER_SUCCESS
      : MANUALLY_PASS_MEMBER_FAIL;

    return (
      <p
        className={cn('text-soClean-180 text-sm', {
          'text-roses': isActionError
        })}
      >
        {confirmationMessage}
      </p>
    );
  }, [isActionError, isActionSuccess]);

  return (
    <MemberConfirmationModal
      childrenClassName="justify-evenly py-4 min-h-32"
      className="w-[25rem]"
      handleConfirm={handleSubmit}
      isButtonDisabled={isButtonDisabled}
      isOpen
      label={MANUALLY_PASS_MEMBER_TITLE}
      onCancelModal={onClose}
      showConfirmationMessage={showConfirmationMessage}
    >
      {!showConfirmationMessage ? ManuallyPassMessage : ConfirmationMessage}
    </MemberConfirmationModal>
  );
};
